import { AxiosResponse } from 'axios';
import { FavoriteListRegister, MyShortCutListResponse, MyShortCuts } from 'types/entity-ddms';
import { httpByDdms } from './settings';

export const fetchMyShortcut = (data: FavoriteListRegister): Promise<MyShortCuts[]> => httpByDdms.post('/myshortcuts/search', data)
  .then((value: AxiosResponse<MyShortCutListResponse>) => value.data.my_shortcuts || []);
